import React from "react";
import { useDispatch } from "react-redux";

import { HANDBOOK_TEMPLATE_LVL, handBookActions } from "pages/HandBook/model/slice";
import { IHandBookTemplateExpenditure } from "pages/HandBook/model/types";

import { useCreateHandbookContext } from "../CreateHandbookContext";
import HandbookTemplateExpenditureModal from "../HandbookTemplateExpenditureModal/HandbookTemplateExpenditureModal";
import AddButton from "shared/ui/controls/AddButton/AddButton";

import styles from "./CreateHandbookTemplateExpenditure.module.scss";

const makeExpenditureItem = (sectionId: string): IHandBookTemplateExpenditure => ({
  id: -Date.now(),
  section_id: Number(sectionId),
  materials: [],
  related_work_id: -1,
  manual_expenditure: {
    id: -Date.now(),
    name: "",
    type: "work",
    measure: "",
    price: "",
    count: "",
    brand: "",
    code: "",
    product_type: "",
    producer: "",
    related_work: -1,
  },
  count: "",
  price: "",
  segment: null,
  parent_section_name: "",
  section_name: "",
});

export interface CreateHandbookTemplateExpenditureProps {
  subSectionId: string;
}

const CreateHandbookTemplateExpenditure: React.FC<CreateHandbookTemplateExpenditureProps> = ({ subSectionId }) => {
  const dispatch = useDispatch();
  const { setIsSectionCreating } = useCreateHandbookContext();

  const addNewExpenditure = () => {
    dispatch(handBookActions.setEditingTemplates(true));
    dispatch(
      handBookActions.localAddTemplateItem({
        item: makeExpenditureItem(subSectionId!),
        lvl: HANDBOOK_TEMPLATE_LVL.EXPENDITURES,
      })
    );
  };

  const openHandbookModal = () => {
    setIsSectionCreating(true);
  };

  return (
    <div className={styles.buttons}>
      <AddButton
        variant="solid"
        small
        text="Добавить работу"
        textPosition="left"
        onClick={addNewExpenditure}
        className={styles.addButton}
      />
      <AddButton
        variant="solid"
        small
        text="Выбрать из справочника"
        textPosition="left"
        onClick={openHandbookModal}
        className={styles.addButton}
      />
      <HandbookTemplateExpenditureModal sectionId={subSectionId} />
    </div>
  );
};

export default React.memo(CreateHandbookTemplateExpenditure);
